import { render, staticRenderFns } from "./loy.vue?vue&type=template&id=b80d4296&scoped=true"
import script from "./loy.vue?vue&type=script&lang=js"
export * from "./loy.vue?vue&type=script&lang=js"
import style0 from "./loy.vue?vue&type=style&index=0&id=b80d4296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80d4296",
  null
  
)

export default component.exports